import React, { useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";

import {
  Box,
  Typography,
  Tabs,
  Tab,
  Grid,
  Card,
  TextField,
  InputAdornment,
  MenuItem,
  IconButton,
  Button,
  Chip,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DownloadIcon from "@mui/icons-material/Download";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import ConfigurationHeader from "../ConfigurationHeader";

export default function Configuration() {
  const [value, setValue] = useState("one");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const [tab, setTab] = useState(0);

  const [page, setPage] = useState(1);
  const [selectedTab1, setSelectedTab1] = useState([]);
const [selectedTab2, setSelectedTab2] = useState([]);
const [selectedTab3, setSelectedTab3] = useState([]);
const [selectedTab4, setSelectedTab4] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const handleCheck = (id) => {
  //   setSelected((prev) =>
  //     prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
  //   );
  // };
  const TabPanel = ({ value, tabValue, children }) => {
    if (value !== tabValue) return null;
    return <Box mt={3}>{children}</Box>;
  };

  /* =======================
     STATS CARDS DATA
  ======================= */
  const statsCards = [
    {
      icon: <DescriptionIcon sx={{ color: "#2563EB" }} />,
      bg: "#E6F0FF",
      count: "Active",
      countColor: "#22C55E",
      title: "Total Profiles",
      value: "24",
    },
    {
      icon: <CheckCircleIcon sx={{ color: "#16A34A" }} />,
      bg: "#ECFDF5",
      count: "+8",
      countColor: "#22C55E",
      title: "Deployed Today",
      value: "156",
    },
    {
      icon: <AccessTimeIcon sx={{ color: "#F97316" }} />,
      bg: "#FEF3E7",
      count: "Pending",
      countColor: "#F97316",
      title: "Queue Status",
      value: "12",
    },
  ];

  const tableData = [
    {
      id: 1,
      name: "Network Config v2",
      desc: "Standard WiFi settings",
      type: "Network",
      typeBg: "#c7d9fa",
      typeColor: "#4a72e1",
      status: "Active",
      statusColor: "#16A34A",
      devices: "245 devices",
      modified: "2 hours ago",
      version: "v2.1.0",
    },
    {
      id: 2,
      name: "Security Policy",
      desc: "Enhanced security settings",
      type: "Security",
      typeBg: "#f3e8ff",
      typeColor: "#8025cf",
      status: "Active",
      statusColor: "#16A34A",
      devices: "89 devices",
      modified: "1 day ago",
      version: "v1.5.2",
    },
  ];

  const mobileFlow = [
    "Configuration Profiles",
    "Device Mapping",
    "Deployment History",
    "Audit Logs",
  ];

  return (
    <>
      {/* ===== HEADER ===== */}
      <ConfigurationHeader />

      {/* ===== STATS CARDS ===== */}
      <Box p={3} mt={isMobile ? "1.5rem" : 0}>
        <Grid container spacing={3}>
          {statsCards.map((card, index) => (
            <Grid item xs={12} key={index}>
              <Card
                sx={{
                  p: 3,
                  width: { xs: "250px", md: "150px" }, 
                  // minWidth: { xs: 300, md: "unset" },
                  borderRadius: "16px",
                  boxShadow: "0px 4px 16px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box display="flex" justifyContent="space-between">
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: "12px",
                      backgroundColor: card.bg,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {card.icon}
                  </Box>

                  <Typography
                    sx={{
                      color: card.countColor,
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    {card.count}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      mt: 2,
                      color: "#6b7280",
                      fontSize: "14px",
                    }}
                  >
                    {card.title}
                  </Typography>

                  <Typography
                    sx={{
                      mt: 0.5,
                      fontSize: "22px",
                      fontWeight: 700,
                      color: "#111827",
                    }}
                  >
                    {card.value}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* ===== TABS ===== */}
      {/* ================= DESKTOP TABS ================= */}

      <Box
        sx={{
          width: "100%",
          maxWidth: {
            xs: 360,

            md: "100%",
          },
          mx: "auto",
          px: { xs: 2, md: 0 },
          overflowX: "hidden",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
            // 🔑 keep indicator inside visible area
            "& .MuiTabs-indicator": {
              maxWidth: "100%",
            },

            // 🔑 scrolling only inside tabs
            "& .MuiTabs-scroller": {
              overflowX: "auto",
            },

            "& .MuiTabs-flexContainer": {
              flexWrap: "nowrap",
            },
          }}
        >
          <Tab value="one" label="Configuration Profiles" />
          <Tab value="two" label="Device mapping" />
          <Tab value="three" label="Deployment History" />
          <Tab value="four" label="Audit logs" />
        </Tabs>
      </Box>

      {/* ================= MOBILE TABS ================= */}

      {/* ===== TAB 1 ===== */}
      <TabPanel value={value} tabValue="one">
        <Box px={3} pb={4}>
          <Card sx={{ borderRadius: 3 }}>
            {/* HEADER */}
            <Box
              sx={{
                px: 3,
                py: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                gap={1}
              >
                <Typography fontWeight={700} fontSize={18}>
                  Configuration Profiles
                </Typography>

                <Box
                  sx={{
                    background: "#F3F4F6",
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  24 profiles
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  gap: 1.5,
                }}
              >
                <Button
                  sx={{
                    background: "#16A34A",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": { background: "#15803D" },
                  }}
                >
                  🚀 Bulk Deploy
                </Button>

                {selectedTab1.length > 0 && (
  <Button variant="contained" color="error">
    Delete
  </Button>
)}

              </Box>
            </Box>

            {/* DESKTOP TABLE */}
            {!isMobile && (
              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#F9FAFB" }}>
                      {[
                        "",
                        "PROFILE",
                        "TYPE",
                        "STATUS",
                        "DEVICES",
                        "LAST MODIFIED",
                        "VERSION",
                        "ACTIONS",
                      ].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "20px 10px",
                            fontSize: 12,
                            color: "#6B7280",
                            fontWeight: 700,
                            textAlign: "left",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {tableData.map((row, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #E5E7EB" }}>
                        <td style={{ padding: 16 }}>
                          <input
  type="checkbox"
  checked={selectedTab1.includes(row.id)}
  onChange={() =>
    setSelectedTab1((prev) =>
      prev.includes(row.id)
        ? prev.filter((i) => i !== row.id)
        : [...prev, row.id]
    )
  }
/>

                        </td>
                        <td style={{ padding: 16 }}>
                          <Typography fontWeight={600}>{row.name}</Typography>
                          <Typography fontSize={13} color="#6B7280">
                            {row.desc}
                          </Typography>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span
                            style={{
                              background: row.typeBg,
                              color: row.typeColor,
                              padding: "8px 12px",
                              borderRadius: 999,
                              fontSize: 14,
                              fontWeight: 600,
                            }}
                          >
                            {row.type}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span>
                            <span
                              style={{ color: row.statusColor, marginRight: 6 }}
                            >
                              ●
                            </span>
                            {row.status}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>{row.devices}</td>
                        <td style={{ padding: 16 }}>{row.modified}</td>
                        <td style={{ padding: 16 }}>{row.version}</td>
                        <td style={{ padding: 16 }}>
                          <IconButton size="small">
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}

            {/* MOBILE CARD VIEW */}
            {isMobile && (
              <Box p={2} display="flex" flexDirection="column" gap={2}>
                {tableData.map((row, i) => (
                  <Card
                    key={i}
                    variant="outlined"
                    sx={{ borderRadius: 2, p: 2 }}
                  >
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontWeight={600}>{row.name}</Typography>
                     <input
  type="checkbox"
  checked={selectedTab1.includes(row.id)}
  onChange={() =>
    setSelectedTab1((prev) =>
      prev.includes(row.id)
        ? prev.filter((i) => i !== row.id)
        : [...prev, row.id]
    )
  }
/>

                    </Box>

                    <Typography fontSize={13} color="text.secondary" mb={1}>
                      {row.desc}
                    </Typography>

                    <Box display="flex" gap={1} mb={1} flexWrap="wrap">
                      <Chip label={row.type} size="small" />
                      <Chip label={row.status} size="small" color="success" />
                    </Box>

                    <Typography fontSize={13}>📱 {row.devices}</Typography>
                    <Typography fontSize={13} color="text.secondary">
                      ⏱ {row.modified} • {row.version}
                    </Typography>
                  </Card>
                ))}
              </Box>
            )}
          </Card>
        </Box>
      </TabPanel>

      {/* ===== TAB 2 ==== */}
      <TabPanel value={value} tabValue="two">
        <Box px={3} pb={4}>
          <Card sx={{ borderRadius: 3 }}>
            {/* HEADER */}
            <Box
              sx={{
                px: 3,
                py: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                gap={1}
              >
                <Typography fontWeight={700} fontSize={18}>
                  Device Mapping
                </Typography>

                <Box
                  sx={{
                    background: "#F3F4F6",
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  24 profiles
                </Box>
              </Box>

              <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" }, 
    alignItems: { xs: "stretch", sm: "center" },
    gap: 1.5,
  }}
>

                <Button
                  sx={{
                    background: "#16A34A",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": { background: "#15803D" },
                  }}
                >
                  🚀 Bulk Deploy
                </Button>

                {selectedTab2.length > 0 && (
  <Button variant="contained" color="error">
    Delete
  </Button>
)}

              </Box>
            </Box>

            {/* DESKTOP TABLE */}
            {!isMobile && (
              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#F9FAFB" }}>
                      {[
                        "",
                        "PROFILE",
                        "TYPE",
                        "STATUS",
                        "DEVICES",
                        "LAST MODIFIED",
                        "VERSION",
                        "ACTIONS",
                      ].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "20px 10px",
                            fontSize: 12,
                            color: "#6B7280",
                            fontWeight: 700,
                            textAlign: "left",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {tableData.map((row, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #E5E7EB" }}>
                        <td style={{ padding: 16 }}>
                          <input
                            type="checkbox"
                            checked={selectedTab2.includes(row.id)}
onChange={() =>
  setSelectedTab2((prev) =>
    prev.includes(row.id)
      ? prev.filter((i) => i !== row.id)
      : [...prev, row.id]
  )
}

                          />
                        </td>
                        <td style={{ padding: 16 }}>
                          <Typography fontWeight={600}>{row.name}</Typography>
                          <Typography fontSize={13} color="#6B7280">
                            {row.desc}
                          </Typography>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span
                            style={{
                              background: row.typeBg,
                              color: row.typeColor,
                              padding: "8px 12px",
                              borderRadius: 999,
                              fontSize: 14,
                              fontWeight: 600,
                            }}
                          >
                            {row.type}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span>
                            <span
                              style={{ color: row.statusColor, marginRight: 6 }}
                            >
                              ●
                            </span>
                            {row.status}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>{row.devices}</td>
                        <td style={{ padding: 16 }}>{row.modified}</td>
                        <td style={{ padding: 16 }}>{row.version}</td>
                        <td style={{ padding: 16 }}>
                          <IconButton size="small">
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}

            {/* MOBILE CARD VIEW */}
            {isMobile && (
              <Box p={2} display="flex" flexDirection="column" gap={2}>
                {tableData.map((row, i) => (
                  <Card
                    key={i}
                    variant="outlined"
                    sx={{ borderRadius: 2, p: 2 }}
                  >
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontWeight={600}>{row.name}</Typography>
                       <input
  type="checkbox"
  checked={selectedTab2.includes(row.id)}
  onChange={() =>
    setSelectedTab2((prev) =>
      prev.includes(row.id)
        ? prev.filter((i) => i !== row.id)
        : [...prev, row.id]
    )
  }
/>

                    </Box>

                    <Typography fontSize={13} color="text.secondary" mb={1}>
                      {row.desc}
                    </Typography>

                    <Box display="flex" gap={1} mb={1} flexWrap="wrap">
                      <Chip label={row.type} size="small" />
                      <Chip label={row.status} size="small" color="success" />
                    </Box>

                    <Typography fontSize={13}>📱 {row.devices}</Typography>
                    <Typography fontSize={13} color="text.secondary">
                      ⏱ {row.modified} • {row.version}
                    </Typography>
                  </Card>
                ))}
              </Box>
            )}
          </Card>
        </Box>
      </TabPanel>

      {/* ===== TAB 3 ==== */}
      <TabPanel value={value} tabValue="three">
        <Box px={3} pb={4}>
          <Card sx={{ borderRadius: 3 }}>
            {/* HEADER */}
            <Box
              sx={{
                px: 3,
                py: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                gap={1}
              >
                <Typography fontWeight={700} fontSize={18}>
                  Deployment History
                </Typography>

                <Box
                  sx={{
                    background: "#F3F4F6",
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  24 profiles
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  gap: 1.5,
                }}
              >
                <Button
                  sx={{
                    background: "#16A34A",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": { background: "#15803D" },
                  }}
                >
                  🚀 Bulk Deploy
                </Button>

                {selectedTab3.length > 0 && (
  <Button variant="contained" color="error">
    Delete
  </Button>
)}
</Box>  
            </Box>

            {/* DESKTOP TABLE */}
            {!isMobile && (
              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#F9FAFB" }}>
                      {[
                        "",
                        "PROFILE",
                        "TYPE",
                        "STATUS",
                        "DEVICES",
                        "LAST MODIFIED",
                        "VERSION",
                        "ACTIONS",
                      ].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "20px 10px",
                            fontSize: 12,
                            color: "#6B7280",
                            fontWeight: 700,
                            textAlign: "left",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {tableData.map((row, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #E5E7EB" }}>
                        <td style={{ padding: 16 }}>
                          <input
                            type="checkbox"
                          checked={selectedTab3.includes(row.id)}
onChange={() =>
  setSelectedTab3((prev) =>
    prev.includes(row.id)
      ? prev.filter((i) => i !== row.id)
      : [...prev, row.id]
  )
}


                          />
                        </td>
                        <td style={{ padding: 16 }}>
                          <Typography fontWeight={600}>{row.name}</Typography>
                          <Typography fontSize={13} color="#6B7280">
                            {row.desc}
                          </Typography>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span
                            style={{
                              background: row.typeBg,
                              color: row.typeColor,
                              padding: "8px 12px",
                              borderRadius: 999,
                              fontSize: 14,
                              fontWeight: 600,
                            }}
                          >
                            {row.type}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span>
                            <span
                              style={{ color: row.statusColor, marginRight: 6 }}
                            >
                              ●
                            </span>
                            {row.status}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>{row.devices}</td>
                        <td style={{ padding: 16 }}>{row.modified}</td>
                        <td style={{ padding: 16 }}>{row.version}</td>
                        <td style={{ padding: 16 }}>
                          <IconButton size="small">
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}

            {/* MOBILE CARD VIEW */}
            {isMobile && (
              <Box p={2} display="flex" flexDirection="column" gap={2}>
                {tableData.map((row, i) => (
                  <Card
                    key={i}
                    variant="outlined"
                    sx={{ borderRadius: 2, p: 2 }}
                  >
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontWeight={600}>{row.name}</Typography>
                       <input
                            type="checkbox"
                          checked={selectedTab3.includes(row.id)}
onChange={() =>
  setSelectedTab3((prev) =>
    prev.includes(row.id)
      ? prev.filter((i) => i !== row.id)
      : [...prev, row.id]
  )
}


                          />
                    </Box>

                    <Typography fontSize={13} color="text.secondary" mb={1}>
                      {row.desc}
                    </Typography>

                    <Box display="flex" gap={1} mb={1} flexWrap="wrap">
                      <Chip label={row.type} size="small" />
                      <Chip label={row.status} size="small" color="success" />
                    </Box>

                    <Typography fontSize={13}>📱 {row.devices}</Typography>
                    <Typography fontSize={13} color="text.secondary">
                      ⏱ {row.modified} • {row.version}
                    </Typography>
                  </Card>
                ))}
              </Box>
            )}
          </Card>
        </Box>
      </TabPanel>

      {/* ===== TAB 4 ==== */}
      <TabPanel value={value} tabValue="four">
        <Box px={3} pb={4}>
          <Card sx={{ borderRadius: 3 }}>
            {/* HEADER */}
            <Box
              sx={{
                px: 3,
                py: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                gap={1}
              >
                <Typography fontWeight={700} fontSize={18}>
                  Audit logs
                </Typography>

                <Box
                  sx={{
                    background: "#F3F4F6",
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  24 profiles
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  gap: 1.5,
                }}
              >
                <Button
                  sx={{
                    background: "#16A34A",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": { background: "#15803D" },
                  }}
                >
                  🚀 Bulk Deploy
                </Button>

                {selectedTab4.length > 0 && (
  <Button variant="contained" color="error">
    Delete
  </Button>
)}

              </Box>
            </Box>

            {/* DESKTOP TABLE */}
            {!isMobile && (
              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#F9FAFB" }}>
                      {[
                        "",
                        "PROFILE",
                        "TYPE",
                        "STATUS",
                        "DEVICES",
                        "LAST MODIFIED",
                        "VERSION",
                        "ACTIONS",
                      ].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "20px 10px",
                            fontSize: 12,
                            color: "#6B7280",
                            fontWeight: 700,
                            textAlign: "left",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {tableData.map((row, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #E5E7EB" }}>
                        <td style={{ padding: 16 }}>
                          <input
                            type="checkbox"
                            checked={selectedTab4.includes(row.id)}
onChange={() =>
  setSelectedTab4((prev) =>
    prev.includes(row.id)
      ? prev.filter((i) => i !== row.id)
      : [...prev, row.id]
  )
}

                          />
                        </td>
                        <td style={{ padding: 16 }}>
                          <Typography fontWeight={600}>{row.name}</Typography>
                          <Typography fontSize={13} color="#6B7280">
                            {row.desc}
                          </Typography>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span
                            style={{
                              background: row.typeBg,
                              color: row.typeColor,
                              padding: "8px 12px",
                              borderRadius: 999,
                              fontSize: 14,
                              fontWeight: 600,
                            }}
                          >
                            {row.type}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>
                          <span>
                            <span
                              style={{ color: row.statusColor, marginRight: 6 }}
                            >
                              ●
                            </span>
                            {row.status}
                          </span>
                        </td>
                        <td style={{ padding: 16 }}>{row.devices}</td>
                        <td style={{ padding: 16 }}>{row.modified}</td>
                        <td style={{ padding: 16 }}>{row.version}</td>
                        <td style={{ padding: 16 }}>
                          <IconButton size="small">
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}

            {/* MOBILE CARD VIEW */}
            {isMobile && (
              <Box p={2} display="flex" flexDirection="column" gap={2}>
                {tableData.map((row, i) => (
                  <Card
                    key={i}
                    variant="outlined"
                    sx={{ borderRadius: 2, p: 2 }}
                  >
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontWeight={600}>{row.name}</Typography>
                     <input
  type="checkbox"
  checked={selectedTab4.includes(row.id)}
  onChange={() =>
    setSelectedTab4((prev) =>
      prev.includes(row.id)
        ? prev.filter((i) => i !== row.id)
        : [...prev, row.id]
    )
  }
/>

                    </Box>

                    <Typography fontSize={13} color="text.secondary" mb={1}>
                      {row.desc}
                    </Typography>

                    <Box display="flex" gap={1} mb={1} flexWrap="wrap">
                      <Chip label={row.type} size="small" />
                      <Chip label={row.status} size="small" color="success" />
                    </Box>

                    <Typography fontSize={13}>📱 {row.devices}</Typography>
                    <Typography fontSize={13} color="text.secondary">
                      ⏱ {row.modified} • {row.version}
                    </Typography>
                  </Card>
                ))}
              </Box>
            )}
          </Card>
        </Box>
      </TabPanel>
    </>
  );
}
